import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { Button, type ButtonProps } from '@rocketlane/ui';
import { FC } from 'react';
import { FontAwesomeIcon } from '../icon/icon';

const getIconSize = (size: ButtonProps['size']) => {
  if (size === 'small') {
    return 12;
  }

  if (size === 'large') {
    return 20;
  }

  return 16;
};

interface Props extends ButtonProps {
  icon?: React.ReactNode;
  dropdownIndicator?: React.ReactNode;
}
export const DropdownTriggerButton: FC<Props> = ({
  children,
  size = 'small',
  dropdownIndicator = (
    <FontAwesomeIcon icon={faChevronDown} size={getIconSize(size)} />
  ),
  icon,
  ...props
}) => {
  return (
    <Button
      {...props}
      type="button"
      variant="ghost"
      size={size}
      leftIcon={icon}
      rightIcon={dropdownIndicator}
    >
      {children}
    </Button>
  );
};
